import { Button } from "./ui/Button";
import { SoundButton } from "./ui/SoundButton";
import { SwitchButton } from "./ui/SwitchButton";
import { BlueBeardWorld, HiddenWolfWorld, KafkaWorld, LittleRedWorld, NightWorld, OgreWorld } from "./worlds";
import { OgreAudioData, KafkaAudioData, NightAudioData, BluebeardAudioData, LittleRedAudioData, HiddenWolfAudioData, } from "@audio/sceneData"; // For some reason, importing from index doesn't work
export const MIN_VOLUME = -64;
export var Action;
(function (Action) {
    Action["BACK"] = "back";
    Action["EXPLORE"] = "explore";
    Action["QUIT"] = "quit";
    Action["PREVIOUS"] = "previous";
    Action["NEXT"] = "next";
    Action["SOUND"] = "sound";
    Action["INFO"] = "info";
    Action["INFO_CLOSE"] = "infoClose";
})(Action || (Action = {}));
export const buttonsConfig = [
    {
        id: Action.BACK,
        icons: ['GoBack'],
        ButtonClass: Button,
        aspectRatio: 1.33,
        position: {
            absolute: [0, 0, -.005],
            relative: [0, -0.2],
            scale: 2,
        }
    },
    {
        id: Action.QUIT,
        icons: ['Back'],
        ButtonClass: Button,
        aspectRatio: 2,
        position: {
            absolute: [0.08, -0.05, 0],
            relative: [-0.5, 0.5],
            scale: .9,
        },
    },
    {
        id: Action.INFO,
        icons: ['Info', 'Close'],
        ButtonClass: SwitchButton,
        aspectRatio: 2,
        position: {
            absolute: [-0.15, -0.05, 0],
            relative: [0.5, 0.5],
            scale: .8,
        },
    },
    {
        id: Action.PREVIOUS,
        icons: ['LongArrowLeft'],
        ButtonClass: Button,
        aspectRatio: 1,
        position: {
            absolute: [-0.04, 0.05, 0],
            relative: [0, -0.5],
            scale: 1,
        }
    },
    {
        id: Action.NEXT,
        icons: ['LongArrowRight'],
        ButtonClass: Button,
        aspectRatio: 1,
        position: {
            absolute: [0.04, 0.05, 0],
            relative: [0, -0.5],
            scale: 1,
        }
    },
    {
        id: Action.EXPLORE,
        icons: ['Explore'],
        ButtonClass: Button,
        aspectRatio: 1.33,
        position: {
            absolute: [0, 0.25, -.005],
            relative: [0, 0],
            scale: 2,
        }
    },
    {
        id: Action.SOUND,
        icons: ['Sound'],
        ButtonClass: SoundButton,
        aspectRatio: 1,
        position: {
            absolute: [-0.05, -0.05, 0],
            relative: [0.5, 0.5],
            scale: 1,
        }
    }
];
export const transformPropKeys = ["position", "rotation", "scale"];
export var AppEvent;
(function (AppEvent) {
    AppEvent["SOUND_MUTED"] = "muted";
    AppEvent["UI_ACTION"] = "uiAction";
    AppEvent["PORTAL_CLICK"] = "portalClick";
    AppEvent["CLICK_INITIATED"] = "clickInitiated";
    AppEvent["CLICK_ENDED"] = "clickEnded";
    AppEvent["LOAD_COMPLETE"] = "loadComplete";
    AppEvent["LIBRARY_VIEW_CHANGE"] = "libraryStateChange";
})(AppEvent || (AppEvent = {}));
export var AppView;
(function (AppView) {
    AppView["LIBRARY"] = "library";
    AppView["WORLD"] = "world";
})(AppView || (AppView = {}));
export var LibraryView;
(function (LibraryView) {
    LibraryView["FOCUS"] = "focus";
    LibraryView["GLOBAL"] = "global";
    LibraryView["IN_PORTAL"] = "inPortal";
})(LibraryView || (LibraryView = {}));
export var PanelMode;
(function (PanelMode) {
    PanelMode["LIBRARY"] = "library";
    PanelMode["WORLD"] = "world";
    PanelMode["NONE"] = "none";
    PanelMode["FOCUS"] = "focus";
    PanelMode["TRANSITION"] = "transition";
})(PanelMode || (PanelMode = {}));
export var WorldId;
(function (WorldId) {
    WorldId[WorldId["LITTLE_RED"] = 1] = "LITTLE_RED";
    WorldId[WorldId["NIGHT"] = 2] = "NIGHT";
    WorldId[WorldId["KAFKA"] = 3] = "KAFKA";
    WorldId[WorldId["BLUEBEARD"] = 4] = "BLUEBEARD";
    WorldId[WorldId["HIDDEN_WOLF"] = 5] = "HIDDEN_WOLF";
    WorldId[WorldId["OGRE"] = 6] = "OGRE";
})(WorldId || (WorldId = {}));
export var TitleId;
(function (TitleId) {
    TitleId[TitleId["OGRE"] = 0] = "OGRE";
    TitleId[TitleId["HIDDEN_WOLF"] = 1] = "HIDDEN_WOLF";
    TitleId[TitleId["LITTLE_RED"] = 2] = "LITTLE_RED";
    TitleId[TitleId["NIGHT"] = 3] = "NIGHT";
    TitleId[TitleId["BLUEBEARD"] = 4] = "BLUEBEARD";
    TitleId[TitleId["KAFKA"] = 5] = "KAFKA";
    TitleId[TitleId["LIBRARY"] = 6] = "LIBRARY";
})(TitleId || (TitleId = {}));
export var PoemId;
(function (PoemId) {
    PoemId[PoemId["OGRE"] = 0] = "OGRE";
    PoemId[PoemId["HIDDEN_WOLF"] = 1] = "HIDDEN_WOLF";
    PoemId[PoemId["LITTLE_RED"] = 2] = "LITTLE_RED";
    PoemId[PoemId["NIGHT"] = 3] = "NIGHT";
    PoemId[PoemId["BLUEBEARD"] = 4] = "BLUEBEARD";
    PoemId[PoemId["KAFKA"] = 5] = "KAFKA";
    PoemId[PoemId["LIBRARY"] = 6] = "LIBRARY";
    PoemId[PoemId["LIBRARY_END"] = 7] = "LIBRARY_END";
})(PoemId || (PoemId = {}));
export const worlds = [
    {
        name: "ogre",
        portalIndex: 1,
        className: OgreWorld,
        audioData: OgreAudioData,
    },
    {
        name: "hiddenWolf",
        portalIndex: 2,
        className: HiddenWolfWorld,
        audioData: HiddenWolfAudioData,
    },
    {
        name: "littleRed",
        portalIndex: 3,
        className: LittleRedWorld,
        audioData: LittleRedAudioData,
    },
    {
        name: "night",
        portalIndex: 4,
        className: NightWorld,
        audioData: NightAudioData,
    },
    {
        name: "bluebeard",
        portalIndex: 5,
        className: BlueBeardWorld,
        audioData: BluebeardAudioData,
    },
    {
        name: "kafka",
        portalIndex: 6,
        className: KafkaWorld,
        audioData: KafkaAudioData,
    },
];
export var KafkaStep;
(function (KafkaStep) {
    KafkaStep[KafkaStep["INIT"] = -1] = "INIT";
    KafkaStep[KafkaStep["TITLES"] = 0] = "TITLES";
    KafkaStep[KafkaStep["ROOM_CLOSE"] = 1] = "ROOM_CLOSE";
    KafkaStep[KafkaStep["TABLE"] = 2] = "TABLE";
    KafkaStep[KafkaStep["HOUSEKEEPER"] = 3] = "HOUSEKEEPER";
    KafkaStep[KafkaStep["SIAMESE"] = 4] = "SIAMESE";
    KafkaStep[KafkaStep["ROOM_FAR"] = 5] = "ROOM_FAR";
    KafkaStep[KafkaStep["WALL"] = 6] = "WALL";
    KafkaStep[KafkaStep["AERIAL_VIEW"] = 7] = "AERIAL_VIEW";
    KafkaStep[KafkaStep["NEIGHBOUR"] = 8] = "NEIGHBOUR";
})(KafkaStep || (KafkaStep = {}));
export const AudioStep = {
    INIT: -1,
    TITLES: 0,
};
export const uiGestureConfig = {
    volume: 1.0,
    shuffle: false,
    samples: [
        {
            name: "hiss",
            duration: 4000,
        },
        {
            name: "jingle1",
            duration: 5000,
        },
        {
            name: "ghost-call",
            duration: 5000,
        },
    ],
};
export const texturesToLoad = [
    { file: 'noise.jpg', repeat: true },
    { file: 'halo.jpg', repeat: true },
    { file: 'checker.png', repeat: true },
    { file: 'hatchB.jpg', repeat: true },
    { file: 'hatchC.jpg', repeat: true },
    { file: 'hatchD.jpg', repeat: true },
    { file: 'titles.jpg', repeat: true },
    { file: 'iconCircle.png', repeat: false },
    { file: 'iconDownArrow.png', repeat: true },
    { file: 'iconCross.png', repeat: true },
    { file: 'iconClose.png', repeat: true },
    { file: 'iconInfo.png', repeat: true },
    { file: 'iconBack.png', repeat: true },
    { file: 'iconGoBack.png', repeat: true },
    { file: 'iconExplore.png', repeat: true },
    { file: 'iconLongArrowLeft.png', repeat: true },
    { file: 'iconLongArrowRight.png', repeat: true },
    { file: 'iconAbout.png', repeat: true },
    { file: 'iconSound.png', repeat: true },
    { file: 'marker.jpg', repeat: true },
    { file: 'poems.png', repeat: false },
    { file: 'shelvesHeight.png', repeat: false },
];
export const modelsToLoad = [
    'night.glb',
    'kafka.glb',
    'bluebeard.glb',
    'hiddenWolf.glb',
    'littleRed.glb',
    'ogre.glb',
    'library.glb',
];
export const loadingMessages = [
    'fear',
    'nightmares',
    'phobia',
    'danger',
    'panic',
    'ghosts',
    'cockroaches',
    'darkness',
    'curses',
    'shadows',
    'spirits',
    'hallucinations',
    'dread',
    'terror',
    'horror',
];
